module.exports = __webpack_public_path__ + "static/boat-large-2e2e209314d478c4177141e5286454eb.png";